module.exports = __webpack_public_path__ + "media/operational-monitoring_en_desktop.68ffdc60.webm";